import { http } from 'services/http';
import type { TCreateOrderReq, TOrderRes } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

type THandleSuccessFn = (data: TOrderRes) => void;

interface ICreateOrderMutationOptions {
  handleSuccess?: THandleSuccessFn;
}

export const useCreateOrder = (options?: ICreateOrderMutationOptions) => {
  return useMutationBase<TOrderRes, unknown, TCreateOrderReq>({
    mutationFn: async (variables) => {
      const res = await http.post<TOrderRes>('/v1/orders', variables);

      return res.data;
    },

    onSuccess: options?.handleSuccess,
  });
};
